// extracted by mini-css-extract-plugin
export default {"container":"Hero_container__mWoHz","img_container":"Hero_img_container__Szeal","details":"Hero_details__7XKif","subtitle":"Hero_subtitle__MJW1P"};